module.exports = __webpack_public_path__ + "static/media/bronze.e00de8d3.png";